import env from "react-dotenv";
import { useQuery, gql } from '@apollo/client';
const axios = require('axios').default;

const REGISTER_USER = `
mutation RegisterUser($user:CreateUserInput!, $password:String!, $registerCognito:Boolean) {
    registerUser(user:$user, password:$password, registerCognito:$registerCognito) {
        code
        success
        message
        user {
            id
            email
        }
    }
}
`;

const FORGOT_PASSWORD = `
mutation InitiateForgotPassword($email: String) {
  initiateForgotPassword(email:$email) {
    success
    message
  }
}
`;

const ME = `
query User {
  me {
    id
    email
    name
    business
    affiliateId
    coi {
      logo
      headerDark
      name
    }
  }
}
`;

const UPDATE_USER = `
mutation UpdateUser($user: UpdateUserInput!) {
  updateUser(user:$user) {
    success,
    message,
    code,
    user {
      id
      email
      name
      business
    }
  }
}
`;

const CREATE_PRODUCT_REQUEST = `
mutation CreateProduct($productRequest: SubmitProductRequestInput!) {
  submitProductRequest(productRequest: $productRequest) {
    success
    productRequest {
        id
        status
        name
        createdAt
        updatedAt
    }
  }
}
`;

const UserService = {
  registerUser: async function(user, password, hasCredentials=false) {
      return axios.post(
        env.API_URL,
        {
          query: REGISTER_USER,
          variables: {
            user: user,
            password: password,
            registerCognito: !hasCredentials
          }
        },
        { headers: { 'Content-Type': 'application/json' } }
      );
  },
  forgotPassword: async function(email) {
    return axios.post(
      env.API_URL,
      {
        query: FORGOT_PASSWORD,
        variables: {
          email: email
        }
      },
      { headers: { 'Content-Type': 'application/json' } }
    );
  },
  me: async function(access_token) {
    return axios.post(
      env.API_URL, 
      {
        query: ME,
        variables: {},
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${access_token}`
        }
      }
    );
  },
  updateUser: async function(user, access_token) {
    return axios.post(
      env.API_URL, 
      {
        query: UPDATE_USER,
        variables: {
          user: user
        },
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${access_token}`
        }
      }
    );
  },
  createProductRequest: async (user, access_token, guest = false) => {
    
    let productRequest = {
      name: user.productRequestProduct,
      link: user.productRequestLink,
      details: user.productRequestDetails,
      urgency: user.productRequestUrgency,
      status: "User Submitted",
    };

    if (guest) {
      productRequest = { ...productRequest, user: { name: user.guestName, email: user.guestEmail } }
    } else {
      productRequest = { ...productRequest, user: { id: user.profile.id, name: user.profile.name, email: user.profile.email}, }
    }
      

    return axios.post(
      env.API_URL,
      {
        query: CREATE_PRODUCT_REQUEST,
        variables: {
          productRequest,
        },
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${access_token}`
        }
      }
    );
  },
}

export default UserService;

